import domWrap from "../utils/domWrap";
import h from "../utils/htm";
import scrollToEl from "../utils/scrollToEl";

const pillarSelectProx = 50;

export default async swipeCards => { // 'comp-swipe-card', combined = true

	if (!swipeCards.forEach)
		return;

	const 	{default: Swiper} = await import('swiper'),
			truckName = document.querySelector('comp-truck-hero > h1')?.textContent || '';

	swipeCards.forEach(swipeCard => {
		const swipeCardWrap = domWrap(swipeCard);
		[...swipeCard.querySelectorAll('comp-card')].forEach(card => card.classList.add('swiper-slide'));
		const swiperH = new Swiper(swipeCard,{
				pagination: '.swiper-pagination',
				paginationClickable: true,
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				onSlideChangeStart(slider){
					scrollToEl(swipeCard);
					cardSwipeEvent(swipeCard.getAttribute('pillar'),slider.activeIndex + 1,slider.slides.length);
				},
				onSlideChangeEnd(){
					localStorage.setItem('sliderUsed', 'true');

				}
			});

		swipeCardWrap.data('swiperBump',() => {
			if(!localStorage.getItem('sliderUsed')){
				swiperH.slideNext(false,4000);
				setTimeout(() => swiperH.slidePrev(false,400),400);
			}
		});

		swipeCardWrap.data('swiperNext',swiperH.slideNext);
		swipeCardWrap.data('swiperPrev',swiperH.slidePrev);	
	});

	let trigger = 0,
		fixed = false,
		waitTimer,
		container = document.querySelector('.page-nav-holder'),
		htmlWrap = domWrap(document.querySelector('html'));


	if(!container) return;

	let containerWrap = domWrap(container);
		
	document.querySelector('.page-nav-inner').prepend(wrap([...document.querySelectorAll('comp-swipe-card[pillar]:not([pillar=""])')].reduce((html,cur) => {
		const pillar = cur.getAttribute('pillar');
		return html + h('button pillar="'+pillar+'"',h('span',pillar)).toString();
	},'') + h('button class="more"',h('span','More...')),'div id="pillar-nav"'));


	htmlWrap
	.on('keyup','body.snapped',function(e){
		switch(e.which){
			case 37:
				domWrap(document.querySelector('comp-swipe-card.active')).data('swiperPrev')();
				break;
			case 38:
				pillarPrev();
				break;
			case 39:
				domWrap(document.querySelector('comp-swipe-card.active')).data('swiperNext')();
				break;
			case 40:
				pillarNext();
				break;
		}
	})
	.on('click','body #pillar-nav button:not(.more)',function(){
		scrollToEl(document.querySelector('comp-swipe-card[pillar="'+this.getAttribute('pillar')+'"]'));
	})
	.on('click','body #pillar-nav button.more',function(){
		const lastCard = [...document.querySelectorAll('comp-swipe-card')].pop();

		if(!lastCard) return;

		const lastCardWrap = domWrap(lastCard);
		window.scroll({
			top: lastCardWrap.offset().top + lastCardWrap.offsetHeight - 70, 
			behavior: 'smooth' 
		});
	}); 

	function findTrigger(){
		let offset = containerWrap.offset();
		if(!offset) return;
		trigger = offset.top + containerWrap.offsetHeight - 60;
	}
	window.addEventListener('load',findTrigger);
	window.addEventListener('resize',findTrigger);
	findTrigger();

	function scrollCheck(){
		var closest = closestPillar({swipeCards,details:false}),
			scrollTop = window.scrollY,
			makeFixed = scrollTop > trigger;
		if(makeFixed !== fixed){
			fixed = makeFixed;
			containerWrap.classList.toggle('fixed',fixed);
		}
		//console.log(closest);
		switch(closest){
			case 'before':
				document.body.classList.remove('snapped');
				[
					...document.querySelectorAll('#pillar-nav button'),
					...swipeCards
				].forEach(element => element.classList.remove('active'));
				break;
			case 'after': 
				document.body.classList.remove('snapped');
				[
					...document.querySelectorAll('#pillar-nav button'),
					...swipeCards
				].forEach(element => element.classList.remove('active'));
				[
					...document.querySelectorAll('#pillar-nav button:not([pillar])')
				].forEach(element => element.classList.add('active'));
				break;
			default:
				document.body.classList.add('snapped');
				[
					...document.querySelectorAll('#pillar-nav button')
				].forEach(element => element.classList.toggle('active',element.getAttribute('pillar') === closest.getAttribute('pillar')));
				[...swipeCards.filter(card => card === closest)].forEach(element => element.classList.remove('active'));
				closest.classList.add('active');
				clearTimeout(waitTimer);
				waitTimer = setTimeout(() => {
					cardSwipeEvent(closest.getAttribute('pillar'),1,closest.querySelectorAll('comp-card').length);
				},500);	
		}
		
	}
	window.addEventListener('scroll',scrollCheck);
	scrollCheck();
	
	const navInner = document.querySelector('.page-nav-inner');
	if(navInner && navInner.querySelectorAll('button').length === 0){
		navInner.closest('.page-nav-holder').classList.add('empty');
	}

	function touchClass(){
		document.firstElementChild.classList.add('touch');
	}
	document.firstElementChild.addEventListener('touchstart',() => document.firstElementChild.removeEventListener('touchstart',touchClass));
};

function wrap(str,wrapper){
	return str ? h(wrapper,str).Node : str;
}

function cardSwipeEvent(pillar,cur,total,truckName){
	(window.dataLayer || []).push({
		'event' : 'UXEvent',
		'eventCategory' : "Truck Page Interaction",
		'eventAction' : "Card Swipe",
		'eventLabel' : truckName + ' - '+pillar+' - '+cur+'/'+total,
		'eventValue' : parseInt((cur / total*100).toString())
	});
}

function closestPillar({swipeCards,details}){
	var scrollTop = window.scrollY,
		scrollBottom = scrollTop + window.innerHeight,
		scrollMid = scrollTop + (window.innerHeight / 2),
		firstCard = domWrap(swipeCards[0]),
		lastCard = domWrap(swipeCards[swipeCards.length - 1]),
		closest;

	if(firstCard.offset().top - scrollTop > pillarSelectProx){
		return 'before';
	}

	if(scrollBottom - (lastCard.offset().top + lastCard.offsetHeight + pillarSelectProx) > 0){
		return 'after';
	}

	closest = swipeCards.reduce((val,card) => {
		const 	cardWrapped = domWrap(card),
				mid = cardWrapped.offset().top + (cardWrapped.offsetHeight / 2);
		return val[0] === undefined || Math.abs(mid - scrollMid) < Math.abs(val[1]) ? [card,mid - scrollMid] : val;
	},[]);

	if(!details){
		return closest[0];
	}
	else {
		return closest;
	}

}

function pillarNext(swipeCards){
	let closest = closestPillar({swipeCards,details:true}),
		next;

	if(typeof closest !== 'string'){
		if(closest[1] > 0){
			// Snap to closest
			scrollToEl(closest[0]);
		}
		else {
			// Snap to next
			next = nextSibling(closest[0],'comp-swipe-card');
			if(next[0]){
				scrollToEl(next);
			}
			
		}
	}
}

function pillarPrev(swipeCards){
	let closest = closestPillar({swipeCards,details:true}),
		prev;
	if(typeof closest !== 'string'){
		if(closest[1] < 0){
			// Snap to closest
			scrollToEl(closest[0]);
		}
		else {
			// Snap to prev
			prev = previousSibling(closest[0],'comp-swipe-card');
			if(prev[0]){
				scrollToEl(prev);
			}
			
		}
	}
}

function nextSibling(elem, selector) {

	// Get the next sibling element
	let sibling = elem.nextElementSibling;

	// If there's no selector, return the first sibling
	if (!selector) return sibling;

	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		sibling = sibling.nextElementSibling
	}

};

function previousSibling(elem, selector) {

	// Get the next sibling element
	let sibling = elem.previousElementSibling;

	// If there's no selector, return the first sibling
	if (!selector) return sibling;

	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		sibling = sibling.previousElementSibling
	}

};